module.exports = __webpack_public_path__ + "img/align_button.a0186e71.svg";